import type { LayoutSize } from './types';

interface SlideLayout {
  gridRows: number;
  gridColumns: number;
  snapDirection: 'x' | 'y';
}

const getGridSize = (layout: SlideLayout) => {
  return layout.snapDirection === 'y' ? layout.gridRows : layout.gridColumns;
};

const getLayoutSizeOverride = (
  hasInteractiveContents: boolean,
  hasImageInset: boolean,
): LayoutSize | null => {
  // this is due to the legacy reasons
  if (hasImageInset) {
    return hasInteractiveContents ? '35%' : '50%';
  }
  return null;
};

const possibleSizes = [0, 0.1, 0.25, 0.33, 0.5, 0.66];

export const getLayoutSize = (
  slideLayout: SlideLayout,
  imageLayoutPosition: {
    start: number;
    end: number;
  },
  hasInteractiveContents: boolean,
  hasImageInset: boolean,
): LayoutSize => {
  const sizeOverride = getLayoutSizeOverride(
    hasInteractiveContents,
    hasImageInset,
  );
  if (sizeOverride) {
    return sizeOverride;
  }

  const gridSize = getGridSize(slideLayout);
  const sizeInGridUnits =
    imageLayoutPosition.end - imageLayoutPosition.start + 1;
  const sizeInGridUnitsAsPercentage = sizeInGridUnits / gridSize;

  // Return closest match from possibleSizes
  const match = possibleSizes.reduce((prev, curr) => {
    return Math.abs(curr - sizeInGridUnitsAsPercentage) <
      Math.abs(prev - sizeInGridUnitsAsPercentage)
      ? curr
      : prev;
  }, 0);

  return `${match * 100}%` as LayoutSize;
};
